<template lang="pug">
aside-modal( :show-close-button="true"
        id="existing-override"
        data-keyboard="false"
        width="w-xxl"
        :loading="loading"
        )
    span(slot="header-text") Existing Override Pricebook
    div.p-a(slot="body")
        form(id="existingForm")
            fieldset(:disabled="loading")
                div.md-form-group
                    label Override Pricebook
                    multiselect(
                        v-model="override",
                        label="name",
                        name='override'
                        track-by="id",
                        v-validate="'required'"
                        placeholder="Type to search",
                        :class="{ 'has-danger': errors.has('override') }"
                        :options="overrideList",
                        :loading="override_loading",
                        :close-on-select="true",
                        :hide-selected="false",
                        :multiple="false",
                        @search-change="loadOverride"
                    )

    button.btn.btn-fw.primary(
        slot="footer",
        @click="submit()",
        :disabled="onLoading('save-override-pricebook')"
    ) 
        v-loading(loader="save-override-pricebook") Save
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        pricebookId: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            override: null,
            overrideList: [],
            override_loading: false,
        };
    },

    computed: {
        loading() {
            return (
                this.onLoading('fetch-override-pricebook') ||
                this.onLoading('save-override-pricebook')
            );
        },
    },

    mounted() {
        this.loadOverride();
        this.registerEvent();
    },

    methods: {
        ...mapActions('override_pricebook', [
            'getOverridePricebook',
            'saveExistingOverride',
        ]),

        toggleModal(action) {
            $('#existing-override').modal(action);
        },

        loadOverride: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.override.pricebook');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.override_loading = true;
            this.$http.get(api, options).then(response => {
                let result = _.filter(
                    response.data.data,
                    data => data['products_count'] > 0,
                );
                this.overrideList = result;
                this.override_loading = false;
            });
        }, 500),

        registerEvent() {
            this.$on('show-override-pricebook', id => {
                if (this.loading) return;
                this.toggleModal('show');
            });
        },

        async submit() {
            let override = [];
            if (!(await this.$validator.validate())) return;

            try {
                override = Object.assign(this.override);
                const details = { override };
                await this.saveExistingOverride(details);
                this.toggleModal('hide');
                this.showToastrSuccess();
                this.getOverridePricebook(this.pricebookId);
            } catch (e) {
                this.showApiError(e);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/existing-override.vue